export default __webpack_public_path__ + "static/media/circle_empty.23e24273.svg";